"use strict";

const Filters = () => {
    const init = () => {
        $(function() {
            var $forms = $('.js-filters-form');
            if ($forms.length > 0) {
                $forms.each(function(i){
                    var $form = $(this);
                    var $radios = $form.find('.js-radio');
                    var $checkboxes = $form.find('.js-checkbox');

                    $radios.on('click', function(){
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                        }else{
                            $radios.filter('[data-name="'+$input.attr('name')+'"]').find('input').prop('checked', false);
                            $input.prop('checked', true);
                        }
                        $form.find('#ajax-submit').trigger('click');
                    });
                    
                    $checkboxes.on('click', function(){
                        var $input = $(this).find('input');
                        if($input.is(':checked')){
                            $input.prop('checked', false);
                        }else{
                            $input.prop('checked', true);
                        }
                        $form.find('#ajax-submit').trigger('click');
                    });

                    if (i !== 0) {
                        $form.find('#ajax-submit').trigger('click');
                    }
                });
            }

            $('.js-filters-toggle').click(function(){
                if($(this).hasClass('inactive') || $(window).scrollTop() > $('.module-home-designs .js-filters-form').offset().top + $('.module-home-designs .js-filters-form').outerHeight()){
                    $(this).removeClass('inactive');
                    $('.module-home-designs .js-filters-form').slideDown();
                }else{
                    $(this).addClass('inactive');
                    $('.module-home-designs .js-filters-form').slideUp();
                }
                $('html, body').animate({
                    scrollTop: $('.module-home-designs .js-filters-form').offset().top
                }, 100);
            });

            $('.js-filters-mobile-toggle').click(function(){
                $(this).siblings('.filters').addClass('open');
            });

            $('.js-filters-close').click(function(){
                $(this).parents('.filters').removeClass('open');
            });

            $(window).trigger('resize');
        });

        $(window).on('resize', function(){
            $('.js-filters-toggle').css('height', $('.module-home-designs .js-filters-form').outerHeight()+'px');
        });
    };

    return {
        init:init
    };
};

export default Filters;